import { dateFilter } from './date-store'

let dates;
dateFilter.subscribe(prop => {
    dates = prop
})
export const getAllDates = () => {
    return dates
}
export const getDate = (key) => {
    return dates[0][key]
}
export const setDate = (key, value) => {
    dateFilter.update(prop => {
        prop[0][key] = value
        return prop
    })
    return
}